var $export = require('./_export');

$export($export.S + $export.F, 'Object', {isObject: require('./_is-object')});


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/core.object.is-object.js
// module id = 734
// module chunks = 35